// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"LogInOption_text-gradient__3fENu","card":"LogInOption_card__3k09d","label":"LogInOption_label__2B2kV"};